import React, { useState, useEffect, useRef } from "react";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Button,
    Dialog,
    Grid,
    DialogActions,
    DialogContent,
    DialogContentText,
    Divider,
    TextField,
    FormControl,
    Radio,
    RadioGroup,
    FormControlLabel,
    TablePagination
} from "@material-ui/core";
import { connect } from "react-redux";
import { setLoading, setSnackInfo } from "../../redux/actions/appAction";
import { CSVLink } from "react-csv";
import { Modal } from "antd";
import { makeStyles, useTheme, withStyles } from "@material-ui/core/styles";
import moment from "moment";
import HttpService from "../../services/httpService";
import Autocomplete from '@material-ui/lab/Autocomplete';

const useStyles = makeStyles((theme) => ({
    table: {
        minWidth: 850,
    },
    textField: {
        width: 100,
    },
    paper: {
        padding: theme.spacing(2),
        margin: "auto",
        maxWidth: 400,
    },
}));

const StyledTableCell = withStyles((theme) => ({
    head: {
        // backgroundColor: "#2C2E3E",
        backgroundColor: "#3F51B5",
        color: "#FFF",
        fontWeight: "500",
        // border: '1px solid black'
    },
    body: {
        fontSize: 14,
        // border: '1px solid red'
    },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        "&:nth-of-type(odd)": {
            backgroundColor: theme.palette.action.hover,
        },
    },
}))(TableRow);

const PaymentExcelDownload = (props) => {
    const [dataForPaymentExcelDownload, setDataForPaymentExcelDownload] = useState([]);
    const [openDialog, setOpenDialog] = useState(false);
    const [value, setValue] = useState("");
    const [details, setDetails] = useState([]);
    const classes = useStyles();
    const [textContent, setTextContent] = useState("");
    const [procurementDetails, setProcurementDetails] = useState({});
    const [invoiceModal, setInvoiceModal] = useState(false);
    const [material, setMaterial] = useState({});
    const [index, setIndex] = useState(null);
    const [updatedMat, setUpdatedMat] = useState(0);
    const [transportationCharge, setTransportationCharge] = useState(0);
    const [freightCharge, setFreightCharge] = useState(0);
    const [gstAmounts, setGstAmounts] = useState(0);
    const [gstOrginalAmount, setGstOriginalAmount] = useState(0);
    const [isGstUpdated, setIsGstUpdated] = useState(false);
    const [isUpdated, setIsUpdated] = useState({
        valuesUpdated: false,
    });
    const [isMaterialUpdated, setIsMaterialUpdated] = useState(false);
    const [materialOriginalPrice, setMaterialOriginalPrice] = useState([]);
    const [editableFields, setEditableFields] = useState({
        transportationCharge: transportationCharge,
        gstAmounts: gstAmounts,
        freightCharge: freightCharge,
    });
    const [selectedOrderId, setSelectedOrderId] = useState("");
    const [openRemarksModal, setOpenRemarksModal] = useState(false);
    const [remarks, setRemarks] = useState("");

  
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [csvData, setCsvData] = useState([]);
    const csvButtonRef = useRef(null);
    const [approvedProjects, setApprovedProjects] = useState([]);
    const [dateFilterType, setDateFilterType] = useState("dateOfInwarded");
    const [selectedVendor, setSelectedVendor] = useState("");
    const [vendorList, setVendorList] = useState([]);
    const [page, setPage] = useState(0); 
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [totalCount, setTotalCount] = useState(0);
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0); 
    };
    // Headers to for csv
    const headers = [
        { key: "orderId", label: "PO No." },
        { key: "inwardingId", label: "Inwarding Id" },
        { key: "inwardedDate", label: "Inwarded Date" },
        { key: "invoiceDate", label: "Invoice Date" },
        { key: "invoiceNumber", label: "Invoice No" },
        { key: "paymentApprovedDate", label: "Payment Approved Date" },
        { key: "vendorName", label: "Vendor Name" },
        { key: "inwardedRate", label: "Inwarded Rate" },
        { key: "inwardedQty", label: "Inwarded Qty" },
        { key: "gst", label: "GST" },
        { key: "freightCharges", label: "Freight Charge" },
        { key: "totalValue", label: "Total Value" },
    ];

    // Function to open invoice Modal
    const openInvoiceModalHelper = (materialId, data, value) => {
        setInvoiceModal(true);
        priceCal(materialId, data, value);
        setMaterial(
            procurementDetails?.materials?.filter(
                (material) => material?.materialId?._id === materialId
            )[0]
        );
        // setIndex(i)
    };

    useEffect(() => {
        fetchAllVendorHandler();
        getDataForPaymentExcelDownloads("", "", "", selectedVendor?._id);
    }, [page, rowsPerPage]);

    // Function to get procurement Details based on the click on action button
    const openInvoiceModalHandler = async (value) => {
        setSelectedOrderId(value?.procurementId?.orderId);
        // setValue(value);
        setDetails(value);
        props.setLoading(true);
        try {
            const result = await HttpService.getProcurementByOrderIdForInwarding(
                value?.procurementId?.orderId
            );
            setProcurementDetails(result.data);
            let arr = result?.data?.materials?.map((el) => el.requestedPrice);
            setMaterialOriginalPrice(arr);
            // setOpenDialog(true)
            openInvoiceModalHelper(
                value?.materialIdOfInwarding?._id,
                result.data,
                value
            );
        } catch (error) {
            console.error(error);
            // props.setSnackInfo(error?.response?.data ?? "Something went wrong", "error")
        }
        props.setLoading(false);
    };

    // function to get inwarding data sent for inwarding approvals
    const getDataForPaymentExcelDownloads = async (startDate, endDate, dateFilterType, vendorId) => {
        props.setLoading(true);
        try {
            const response = await HttpService.getDataForPaymentExcelDownloads(
                startDate, 
                endDate, 
                dateFilterType, 
                vendorId,
                page + 1,  // +1 because backend expects page to start from 1
                rowsPerPage
            );
            
            setDataForPaymentExcelDownload(response?.data?.data); // Updated to access the data array
            setTotalCount(response?.data?.pagination?.total); // Set total count from pagination data
        } catch (err) {
            props.setSnackInfo(
                err?.response?.data ?? "Something went wrong",
                "error"
            );
        }
        props.setLoading(false);
    };

    // fucntion to get all vendor's list
    const fetchAllVendorHandler = async () => {
        try {
            const response = await HttpService.getAllVendors();
            setVendorList(response.data);
        } catch (error) {
            console.error("Error -> ", error);
            props.setSnackInfo("Something Went Wrong", "error");
        }
    }

    // Function to handle remarks input
    const remarksInputHandler = async (e) => {
        setRemarks(e.target.value);
        // if (e.target.value.trim() === "") return props.setSnackInfo("Please Enter Remarks", "error");
    };

    // A helper function to calculate the necessary fields when rate, gst, freight, or transportation charges are changed
    const priceCal = (materialId, data, value) => {
        let total = 0;
        let subTotal = 0;
        let presicionDiff = 0;
        let toatlGstAmount = 0;
        let totalQty = 0;
        data.materials.forEach((mat) => {
            if (
                mat.materialId._id.toString() === materialId.toString() &&
                mat?.materialId?._id?.toString() ===
                value?.materialIdOfInwarding?._id?.toString()
            ) {
                // mat.materialTotal = +mat.requestedQuantity * +mat.requestedPrice || +mat.materialId.pricePerUnit;
                mat.materialTotal =
                    +value?.InwardingRecords?.inwardedQty * +mat.requestedPrice ||
                    +mat.materialId.pricePerUnit;
                total += mat.materialTotal;
                // totalQty += mat.requestedQuantity;
                totalQty += +value?.InwardingRecords?.inwardedQty;
                mat.isAdded = true;
            }
        });

        if (data.discount) {
            // total = total - data.discount;
            let discountAmount = (data.discount / 100) * total; // Calculate the discount amount
            total -= discountAmount;
        } else {
            data.discount = 0;
        }
        subTotal = total;

        if (data.gstRequired) {
            data.gstDetails.forEach((gstDetail) => {
                gstDetail.gstAmount = Number(
                    Number.parseFloat((gstDetail.rate * total) / 100).toFixed(2)
                );
                toatlGstAmount += gstDetail.gstAmount;
            });
            total = total + toatlGstAmount;
        } else {
            toatlGstAmount = 0;
        }

        if (value.InwardingRecords.freightCharge) {
            total = total + +value.InwardingRecords.freightCharge;
        } else {
            data.freight = 0;
        }

        if (data.transportationCharge) {
            total = total + data.transportationCharge;
        } else {
            data.transportationCharge = 0;
        }

        data.totalQty = +totalQty;
        data.subTotal = +subTotal;
        data.grandTotal = +total;
        presicionDiff =
            Math.round(total) -
            Number(Number.parseFloat(subTotal).toFixed(2)) -
            Number(Number.parseFloat(toatlGstAmount).toFixed(2)) +
            Number(Number.parseFloat(data.discount).toFixed(2)) -
            Number(Number.parseFloat(data.transportationCharge).toFixed(2)) -
            Number(Number.parseFloat(data.freight).toFixed(2));
        data.presicionDiff = Number.parseFloat(presicionDiff).toFixed(2);
        // let word = numWords(Math.round(+procurementDetails.grandTotal));
        // procurementDetails.amountInWords = word.toUpperCase();
        setTransportationCharge(data?.transportationCharge);
        setFreightCharge(value.InwardingRecords.freightCharge);
        setGstAmounts(toatlGstAmount);
        setEditableFields({ ...editableFields, gstAmounts: data?.gstDetails });
        setUpdatedMat(data.grandTotal);
        setProcurementDetails(data);
        return data;
    };

    // Function to handle the action of finance the procurement status when it is submitted
    const handleFinanceInwardingActionForFreightChangeApproval = async () => {
        // Set loading state to true to indicate a process is ongoing
        props.setLoading(true);

        // Check if remarks are entered, if not show a warning and return
        if (remarks.trim().length === 0) {
            props.setSnackInfo(`Please Enter ${textContent} Remarks Before Submitting`, "warning");
            props.setLoading(false);
            return;
        }


        // Create an object to hold the updated procurement details and status
        let updateObj = {
            status: value,
            remarks: remarks.trim(),
            freightCharge: freightCharge,
            procurementId: details.procurementId._id,
            inwardingRecordId: details.InwardingRecords._id,
        };

        // If values have been updated, include price and GST modify the information in object
        if (isUpdated.valuesUpdated === true) {
            updateObj.isPricesUpdated = true;
            updateObj.isGstUpdated = isGstUpdated;
            updateObj.fields = editableFields;
        }

        // If materials have been updated, include the updated materials information
        if (isMaterialUpdated === true) {
            updateObj.isMaterialUpdated = isMaterialUpdated;
            updateObj.materials = procurementDetails?.materials;
        }

        try {
            // Send the finance action status request to the backend API
            const response = await HttpService.updateInwardingStatusSentForFreightApproval(updateObj);

            // Display success message if the response was successful
            props.setSnackInfo(response?.data?.msg ?? "Updated Successfully", response?.data?.type ?? "success");
        } catch (err) {
            console.error("Error -> ", err);

            // Display error message if something went wrong
            props.setSnackInfo(err?.response?.data?.msg ?? "Something went wrong", err?.response?.type ?? "error");
        }

        // Close the remarks modal and reset remarks input
        setOpenRemarksModal(false);
        setRemarks("");

        // Close the invoice modal
        setInvoiceModal(false);

        // Set loading state to false to indicate the process has completed
        props.setLoading(false);

        // Refresh data for inwarding approvals
        getDataForPaymentExcelDownloads("", "", "", "");
    };


    // function to handle price change of material
    const materialPriceChangeHandler = (index, event) => {
        // Log the index and the new value
        if (+event.target.value <= 0) return props.setSnackInfo("Please Enter Value Greater than 0", "warning");

        // Set isMaterialUpdated to true
        setIsMaterialUpdated(true);

        // Log the original material price

        // Check if the new price is greater than the original requested price
        if (+event.target.value > +materialOriginalPrice[index]) {
            // Display an error message and return if the new price is greater
            props.setSnackInfo(
                "New Rate can't be greater than original Requested Rate",
                "error"
            );
            return;
        }
        // Create a copy of procurementDetails
        const updatedProcurementDetails = { ...procurementDetails };
        // Update the requested price for the material at the specified index
        updatedProcurementDetails.materials[index].requestedPrice =
            event.target.value;

        // Initialize variables for calculations
        let total = 0;
        let subTotal = 0;
        let presicionDiff = 0;
        let toatlGstAmount = 0;
        let totalQty = 0;

        // Calculate total and total quantity for all materials
        updatedProcurementDetails.materials.forEach((mat, i) => {
            if (mat.isAdded === true) {
                // mat.materialTotal = +mat.requestedQuantity * +mat.requestedPrice || +mat.materialId.pricePerUnit;
                mat.materialTotal =
                    +details?.InwardingRecords?.inwardedQty * +mat.requestedPrice ||
                    +mat.materialId.pricePerUnit;
                total += mat.materialTotal;
                // totalQty += mat.requestedQuantity;
                totalQty += details?.InwardingRecords?.inwardedQty;
            }
        });

        // Calculate subTotal
        if (updatedProcurementDetails.discount) {
            // total = total - updatedProcurementDetails.discount;
            let discountAmount = (updatedProcurementDetails.discount / 100) * total; // Calculate the discount amount
            total -= discountAmount;
        } else {
            updatedProcurementDetails.discount = 0;
        }
        subTotal = total;

        // Calculate GST amounts
        if (updatedProcurementDetails.gstRequired) {
            updatedProcurementDetails.gstDetails.forEach((gstDetail) => {
                gstDetail.gstAmount = Number(
                    Number.parseFloat((gstDetail.rate * total) / 100).toFixed(2)
                );
                toatlGstAmount += gstDetail.gstAmount;
            });
            total = total + toatlGstAmount;
        } else {
            toatlGstAmount = 0;
        }

        // Calculate total with freight
        if (details.InwardingRecords.freightCharge) {
            total = total + details.InwardingRecords.freightCharge
        } else {
            updatedProcurementDetails.freight = 0;
        }

        // Calculate total with transportation charge
        if (updatedProcurementDetails.transportationCharge) {
            total = total + updatedProcurementDetails.transportationCharge;
        } else {
            updatedProcurementDetails.transportationCharge = 0;
        }

        // Update procurementDetails with calculated values
        updatedProcurementDetails.totalQty = +totalQty;
        updatedProcurementDetails.subTotal = +subTotal;
        updatedProcurementDetails.grandTotal = +total;
        presicionDiff =
            Math.round(total) -
            Number(Number.parseFloat(subTotal).toFixed(2)) -
            Number(Number.parseFloat(toatlGstAmount).toFixed(2)) +
            Number(Number.parseFloat(updatedProcurementDetails.discount).toFixed(2)) -
            Number(
                Number.parseFloat(
                    updatedProcurementDetails.transportationCharge
                ).toFixed(2)
            ) -
            Number(Number.parseFloat(updatedProcurementDetails.freight).toFixed(2));
        updatedProcurementDetails.presicionDiff =
            Number.parseFloat(presicionDiff).toFixed(2);

        // Update state with new values
        setTransportationCharge(updatedProcurementDetails?.transportationCharge);
        setFreightCharge(details.InwardingRecords.freightCharge);
        setGstAmounts(toatlGstAmount);
        setGstOriginalAmount(toatlGstAmount);
        setEditableFields({
            ...editableFields,
            gstAmounts: updatedProcurementDetails?.gstDetails,
        });
        setUpdatedMat(updatedProcurementDetails.grandTotal);

        // Update the requested price for the material at Inwarding approvals
        setDetails((prevState) => ({
            ...prevState,
            InwardingRecords: {
                ...prevState.InwardingRecords,
                inwardedRate: event.target.value
            }
        }));

        // updating the procurementDetails
        setProcurementDetails(updatedProcurementDetails);

        // Return the updated procurementDetails
        // return updatedProcurementDetails;
    };

    // function to handle change in GST
    const gstChangeHandler = (event) => {
        if (+event.target.value > +gstOrginalAmount) {
            return props.setSnackInfo(
                "GST Amount can't be greater than Requested GST Amount",
                "error"
            );
        }
        setGstAmounts(event.target.value);
        setIsGstUpdated(true);
        let val = (+event.target.value / procurementDetails?.grandTotal) * 100;
        procurementDetails.grandTotal =
            procurementDetails?.grandTotal - gstAmounts + +event.target.value;
        setEditableFields({ ...editableFields, gstAmounts: +val.toFixed(0) });
    };

    // function to handle change in transportation charges
    const transportationChargesChangeHandler = (event) => {
        setTransportationCharge(event.target.value);
        procurementDetails.grandTotal =
            procurementDetails?.grandTotal -
            transportationCharge +
            +event.target.value;
        setEditableFields((prevState) => ({
            ...editableFields,
            transportationCharge: +event.target.value,
        }));
    };

    // function to handle change in freight charges
    const freightChargesChangeHandler = (event) => {
        if (+event.target.value <= 0) return props.setSnackInfo("Please Enter Value Greater than 0", "warning");
        setFreightCharge(+event.target.value);
        const procDetailObj = { ...procurementDetails };
        procDetailObj.grandTotal = procDetailObj?.grandTotal - freightCharge + +event.target.value;
        // procDetailObj.freight = +event.target.value;

        setProcurementDetails(procDetailObj);
        setEditableFields({
            ...editableFields,
            freightCharge: +event.target.value,
        });
    };

    // Function to Open Remarks Modal
    const openRemarksModalHandler = (status) => {
        if (status === "Approved") {
            setTextContent("Approval");
        }
        if (status === "Rejected") {
            setTextContent("Rejection");
        }
        setValue(status);
        setOpenRemarksModal(true);
    };

    // Funtion to close Remarks Modal
    const closeRemarksModalHandler = () => {
        setOpenRemarksModal(false);
        setRemarks("");
    };

    // Funtion to get type of the file do display
    const getFileType = (url) => {
        const extension = url?.split(".").pop()?.toLowerCase();
        if (extension === "pdf") {
            return "pdf";
        } else if (
            extension === "jpg" ||
            extension === "jpeg" ||
            extension === "png" ||
            extension === "gif"
        ) {
            return "image";
        } else {
            return "unknown";
        }
    };

    // function to download data in csv
    const csvDownloadHandler = async () => {
        setLoading(true);
        try {
            let csvArray = [];

            for (let i = 0; i < dataForPaymentExcelDownload.length; i++) {
                let obj = {
                    orderId: dataForPaymentExcelDownload[i]?.procurementId?.orderId || "N/A",
                    inwardingId: dataForPaymentExcelDownload[i]?.InwardingRecords?.inwardingId || "N/A",
                    inwardedDate: dateFormatter(dataForPaymentExcelDownload[i]?.InwardingRecords?.dateOfInwarded || ""),
                    invoiceDate: dateFormatter(dataForPaymentExcelDownload[i]?.InwardingRecords?.invoiceDate || ""),
                    invoiceNumber: dataForPaymentExcelDownload[i]?.InwardingRecords?.invoiceNumber,
                    paymentApprovedDate: dateFormatter(dataForPaymentExcelDownload[i]?.InwardingRecords?.paymentApprovedDate || ""),
                    vendorName: dataForPaymentExcelDownload[i]?.InwardingRecords?.vendorId?.name,
                    inwardedRate: dataForPaymentExcelDownload[i]?.InwardingRecords?.inwardedRate?.toFixed(2),
                    inwardedQty: dataForPaymentExcelDownload[i]?.InwardingRecords?.inwardedQty.toFixed(2),
                    gst: dataForPaymentExcelDownload[i]?.gstDetails[0]?.gstRate.toFixed(2),
                    freightCharges: dataForPaymentExcelDownload[i]?.InwardingRecords?.freightCharge,
                    totalValue: (+dataForPaymentExcelDownload[i]?.InwardingRecords?.inwardedValueWithGST + (+dataForPaymentExcelDownload[i]?.InwardingRecords?.freightCharge || 0))?.toFixed(2),
                };
                csvArray.push(obj);
                obj = {
                    orderId: "",
                    inwardingId: "",
                    inwardedDate: "",
                    invoiceDate: "",
                    invoiceNumber: "",
                    paymentApprovedDate: "",
                    vendorName: "",
                    poQty: "",
                    inwardedQty: "",
                    gst: "",
                    freightCharges: "",
                    totalValue: "",
                };
                csvArray.push(obj);
            }
            setCsvData(csvArray);
            downloadExcel();
        } catch (error) {
            console.error("error", error);
            props?.setSnackInfo(
                error?.response?.data?.message ?? "Something went wrong",
                "error"
            );
        }
        setLoading(false);
    };

    // a helper function for csv download
    const downloadExcel = () => {
        setLoading(true);
        try {
            setTimeout(() => {
                csvButtonRef.current.link.click();
            });
        } catch (err) {
            console.error(err.message);
        }
        setLoading(false);
    };

    // function to format date
    const dateFormatter = (inputDate) => {
        if (inputDate === "") return "N/A";
        const date = new Date(inputDate);
        const day = date.getDate();
        const month = date.getMonth() + 1;
        const year = date.getFullYear();

        const formattedDay = day < 10 ? "0" + day : day;
        const formattedMonth = month < 10 ? "0" + month : month;

        const formattedDate = formattedDay + "-" + formattedMonth + "-" + year;
        return formattedDate;
    };

    // function to clear date filter
    const clearFilterDate = (e) => {
        setPage(0);
        setStartDate("");
        setEndDate("");
        setDateFilterType("dateOfInwarded");
        setSelectedVendor("");
        getDataForPaymentExcelDownloads("", "", "", "");
    };

    // filter function for date range
    const inwardedDataOnSelectedDateHandler = () => {
        setPage(0); 
        getDataForPaymentExcelDownloads(startDate, endDate, dateFilterType, selectedVendor?._id);
    };

    // Handle Radio change for dates of payment requests either inwarded date / payment approved date
    const handleRadioChange = (event) => {
        try {
            setDateFilterType(event.target.value);
        } catch (error) {
            console.error("Error -> ", error);
        }
    }

    // function to handle vendor select
    const handleVendorChange = async (event, value) => {
        try {
            setPage(0);
            setSelectedVendor(value);
        } catch (error) {
            console.error("Error -> ", error);
            props.setSnackInfo("Something Went Wrong", "error");
        }
    }

    // function to download bank format report
    const downloadBankReport = () => {
        try {
            /*
            if (!startDate || !endDate) {
                return props.setSnackInfo(
                   "Start date and end date are required.",
                    "error"
                );
            }
            */
            generateBankFormatReport(startDate, endDate, dateFilterType, selectedVendor?._id);
        } catch (error) {
            console.error("Error -> ", error);
            props.setSnackInfo(
                error?.response?.data ?? "Something went wrong",
                "error"
            );
        }
    }

    // function to generate bank format report 
    const generateBankFormatReport = async (startDate, endDate, dateFilterType, vendorId) => {
        props.setLoading(true);
        try {
            const response = await HttpService.generateBankFormatReportForApprovedInwarding(startDate, endDate, dateFilterType, vendorId);
            window.location.href = response.data.path;		
        } catch (err) {
            console.error("Error -> ", err);
            props.setSnackInfo(
                err?.response?.data ?? "Something went wrong",
                "error"
            );
        }
        props.setLoading(false);
    };

    return (
        <div>

            <div
                style={{
                    marginBottom: 20,
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >
                <Paper className={classes.paper}>
                    <center>
                        <h2>Payment Excel Download</h2>
                    </center>
                </Paper>
            </div>

            {/* Date Filter component */}
            <Paper style={{ padding: 10, marginBottom: 10 }}>
                <FormControl component="fieldset" className={classes.root}>
                    <RadioGroup aria-label="type" name="type" value={dateFilterType} onChange={handleRadioChange}>
                        <div className='modal-header-radio'>
                            <FormControlLabel value="dateOfInwarded" control={<Radio />} label="Inwarded Date" />
                            <FormControlLabel value="paymentApprovedDate" control={<Radio />} label="Payment Approved Date" />
                        </div>
                    </RadioGroup>
                </FormControl>
                {/* Select Vendor Button */}
                <FormControl component="fieldset" className={classes.root}>
                    <Autocomplete
                        value={selectedVendor}
                        onChange={handleVendorChange}
                        id="vendor-name-dropdown"
                        options={vendorList}
                        getOptionLabel={(option) => option.name}
                        style={{ width: 500, margin: 10 }}
                        renderInput={(params) => <TextField {...params} label="Vendor Search" fullWidth variant="outlined" />}
                    />
                </FormControl>
                <Grid container style={{ display: "flex", alignItems: "center" }}>
                    <Grid item md={3} xs={12}>
                        <TextField
                            id="date"
                            name="startDate"
                            label="Start Date"
                            type="date"
                            value={startDate}
                            onChange={(e) => setStartDate(e.target.value)}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            fullWidth
                        // className={classes.textField}
                        />
                    </Grid>
                    <Grid item md={1} xs={12}></Grid>
                    <Grid item md={3} xs={12}>
                        <TextField
                            id="date"
                            name="endDate"
                            label="End Date"
                            type="date"
                            value={endDate}
                            onChange={(e) => setEndDate(e.target.value)}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            fullWidth
                        // className={classes.textField}
                        />
                    </Grid>
                    <Grid item md={3} xs={12}>
                        <Button
                            variant="contained"
                            color="primary"
                            // disabled={!startDate || !endDate}
                            onClick={inwardedDataOnSelectedDateHandler}
                            style={{ marginLeft: 10 }}
                        >
                            Submit
                        </Button>
                    </Grid>
                    <Grid item md={2} xs={12}>
                        <Button
                            variant="contained"
                            color="secondary"
                            onClick={clearFilterDate}
                        >
                            Clear Filter
                        </Button>
                    </Grid>
                </Grid>
            </Paper>

            <Grid container style={{ display: "flex", alignItems: "center" }}>
                {/* Download CSV Button */}
                <Grid item md={3} xs={12}>
                    <div style={{ display: "flex", alignItems: "center" }}>
                        <CSVLink
                            headers={headers}
                            filename={"Inwarding Payment Excel " + new Date().toLocaleDateString().replaceAll("/", "_") + ".csv"}
                            data={csvData}
                            ref={csvButtonRef}
                        />
                        <Button
                            onClick={csvDownloadHandler}
                            style={{ margin: 10, backgroundColor: "green" }}
                            variant="contained"
                            color="success"
                        >
                            Download CSV
                        </Button>
                    </div>
                </Grid>
                {/* Download Bank Format Button */}
                <Grid item md={3} xs={5}>
                    <Button
                        onClick={downloadBankReport}
                        style={{ margin: 10, backgroundColor: "green" }}
                        variant="contained"
                        color="success"
                    >
                        Generate Bank Format Report
                    </Button>
                </Grid>
            </Grid>

            {/* Table for displaying data sent for New Inwarding Approvals */}
            <TableContainer TableContainer component={Paper}>
            <TablePagination
                    component="div"
                    count={totalCount}
                    page={page}
                    onPageChange={handleChangePage}
                    rowsPerPage={rowsPerPage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    rowsPerPageOptions={[10, 25, 50, 100, 200, 500]}
                />
                <Table
                    className={classes.table}
                    size="small"
                    aria-label="customized table"
                    stickyHeader
                >
                    <TableHead>
                        <TableRow>
                            <StyledTableCell>Sl No</StyledTableCell>
                            <StyledTableCell>PO No.</StyledTableCell>
                            <StyledTableCell>Inwarding Id</StyledTableCell>
                            <StyledTableCell>Inwarded Date</StyledTableCell>
                            <StyledTableCell>Payment Approved Date</StyledTableCell>
                            <StyledTableCell>Invoice Date</StyledTableCell>
                            <StyledTableCell>Invoice No.</StyledTableCell>
                            <StyledTableCell>Vendor Name</StyledTableCell>
                            <StyledTableCell>Inwarded Rate</StyledTableCell>
                            <StyledTableCell>Inwarded Qty</StyledTableCell>
                            <StyledTableCell>GST</StyledTableCell>
                            <StyledTableCell>Freight Charges</StyledTableCell>
                            <StyledTableCell>Total Value (With GST)</StyledTableCell>
                            {/* <StyledTableCell>Action</StyledTableCell> */}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {dataForPaymentExcelDownload?.map((el, i) => {
                            return (
                                <StyledTableRow key={page * rowsPerPage +i + 1}>
                                    <StyledTableCell>{page * rowsPerPage +i + 1}</StyledTableCell>
                                    <StyledTableCell>
                                        {el?.procurementId?.orderId}
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        {el?.InwardingRecords?.inwardingId}
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        {moment(el?.InwardingRecords?.dateOfInwarded).format(
                                            "DD-MM-YYYY"
                                        )}
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        {el?.InwardingRecords?.paymentApprovedDate ?
                                            moment(el.InwardingRecords.paymentApprovedDate).format("DD-MM-YYYY") :
                                            "N/A"
                                        }
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        {el?.InwardingRecords?.invoiceDate
                                            ? moment(el.InwardingRecords.invoiceDate).format("DD-MM-YYYY")
                                            : "N/A"}
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        {el?.InwardingRecords?.invoiceNumber}
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        {el?.InwardingRecords?.vendorId?.name}
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        {el?.InwardingRecords?.inwardedRate?.toFixed(2)}
                                    </StyledTableCell>
                                    <StyledTableCell>{el?.InwardingRecords?.inwardedQty?.toFixed(2)}</StyledTableCell>
                                    <StyledTableCell>
                                        {el?.gstDetails[0]?.gstRate?.toFixed(2) || "N/A"}
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        {el?.InwardingRecords?.freightCharge?.toFixed(2) || 0}
                                    </StyledTableCell>
                                    <StyledTableCell>{(+el?.InwardingRecords?.inwardedValueWithGST + (+el?.InwardingRecords?.freightCharge || 0))?.toFixed(2)}</StyledTableCell>
                                    {/*
                                    <StyledTableCell>
                                        <>
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                // onClick={() => openInvoiceModalHandler(el)}
                                            >
                                                Action
                                            </Button>
                                        </>
                                    </StyledTableCell>
                                    */}
                                </StyledTableRow>
                            );
                        })}
                    </TableBody>
                </Table>
              
            </TableContainer>

            {/* PO Invoice Modal */}
            {/*
            <Modal
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
                title={`New Inwarding Approval | ${selectedOrderId}`}
                centered
                open={invoiceModal}
                onCancel={() => setInvoiceModal(false)}
                width={1500}
                maskClosable={true}
                footer={null}
            >
                <div style={{ display: "flex", width: "100%" }}>
                    <div style={{ border: "1px solid #000", flex: 1, padding: "2px" }}>
                        <div
                            className="container"
                            style={{ width: "100%", marginTop: "2%" }}
                        >
                            <div>
                                <div>
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td rowSpan="3" style={{ width: "50%" }}>
                                                    <div className="invoice">Invoice to:</div>
                                                    <div className="invoice-to">
                                                        <b>Decorpot Pvt Ltd.</b>
                                                        <div>
                                                            #17, 18th Cross Rd, Sector 3, HSR Layout,
                                                            Bengaluru - 560102
                                                        </div>
                                                        <div className="gstno">Gst No-29AAWCS3842H1ZO</div>
                                                        <div>State Name : Karnataka, Code : 29</div>
                                                        <div>E-Mail: sales@decorpot.com</div>
                                                    </div>
                                                </td>
                                                <td style={{ width: "25%" }}>
                                                    <div>Voucher No.</div>
                                                    <div className="vou-no">
                                                        <b>{procurementDetails?.orderId}</b>
                                                    </div>
                                                </td>
                                                <td style={{ width: "25%" }}>
                                                    <div>Dated:</div>
                                                    <div className="vou-no">
                                                        <b>
                                                            {moment(procurementDetails?.createdAt).format(
                                                                "DD-MM-YYYY"
                                                            )}
                                                        </b>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td style={{ width: "25%" }}>&nbsp;</td>
                                                <td style={{ width: "25%" }}>
                                                    <div>Mode/Terms of Payment</div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td style={{ width: "25%" }}>
                                                    <div>Supplier's Ref./Order No.</div>
                                                    <div className="vou-no">
                                                        <b>{procurementDetails?.orderId}</b>
                                                    </div>
                                                </td>
                                                <td style={{ width: "25%" }}>
                                                    <div>Other Reference(s)/Comments</div>
                                                    <div className="vou-no">
                                                        <b>{procurementDetails?.comment}</b>
                                                    </div>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td rowSpan="2" style={{ width: "50%" }}>
                                                    <div className="invoice">Supplier</div>
                                                    <div className="invoice-to">
                                                        <b>{procurementDetails?.vendorId?.name}</b>
                                                        <div>{procurementDetails?.vendorId?.address}</div>
                                                        <div className="row">
                                                            <div
                                                                className="col-md-2"
                                                                style={{ float: "left" }}
                                                            >
                                                                GSTIN/UIN
                                                            </div>
                                                            <div className="col-md-10">
                                                                :&nbsp;
                                                                {procurementDetails?.vendorId?.gstinNumber}
                                                            </div>
                                                            <div className="row">
                                                                <div
                                                                    className="col-md-2"
                                                                    style={{ float: "left" }}
                                                                >
                                                                    State Name
                                                                </div>
                                                                <div className="col-md-10">
                                                                    :&nbsp;Karnataka, Code : 29
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div>Inwarding Id</div>
                                                    <div className="vou-no">
                                                        <b>{details?.InwardingRecords?.inwardingId}</b>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div>Destination</div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td colSpan="1">
                                                    <div>Terms of Delivery</div>
                                                </td>
                                                <td style={{ width: "25%" }}>
                                                    <div>Invoice No.</div>
                                                    <div className="vou-no">
                                                        <b>{details?.InwardingRecords?.invoiceNumber}</b>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                                <div>
                                    <Table size="small" aria-label="custom pagination table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Sl. No.</TableCell>
                                                <TableCell>Description of Goods</TableCell>
                                                <TableCell>Due On</TableCell>
                                                <TableCell>Quantity</TableCell>
                                                <TableCell>Rate</TableCell>
                                                <TableCell>per</TableCell>
                                                <TableCell>Disc. %</TableCell>
                                                <TableCell>Amount</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableHead>
                                            {procurementDetails?.materials?.map(
                                                (material, index) =>
                                                    material.isAdded && (
                                                        <TableRow key={index}>
                                                            <TableCell>{index + 1}</TableCell>
                                                            <TableCell>
                                                                <div>
                                                                    <b>{material?.materialId?.code}</b>
                                                                </div>
                                                                <br />
                                                                <div className="desc">
                                                                    [
                                                                    {material?.materialId?.aliasName
                                                                        ? material?.materialId?.aliasName
                                                                        : material?.materialId.name}
                                                                    ]
                                                                </div>
                                                                <br />
                                                                {material?.remark && (
                                                                    <div className="desc">{material?.remark}</div>
                                                                )}
                                                            </TableCell>
                                                            <TableCell>45 Days</TableCell>
                                                            <TableCell>
                                                                {details?.InwardingRecords?.inwardedQty}
                                                            </TableCell>
                                                            <TableCell>
                                                                {material?.requestedPrice}
                                                            </TableCell>
                                                            <TableCell>{material?.unitId.name}</TableCell>
                                                            <TableCell>
                                                                {procurementDetails?.discount}
                                                            </TableCell>
                                                            <TableCell>
                                                                ₹
                                                                {(
                                                                    material?.materialTotal?.toFixed(2) -
                                                                    (procurementDetails?.discount *
                                                                        material?.materialTotal) /
                                                                    100
                                                                ).toFixed(2)}
                                                            </TableCell>
                                                        </TableRow>
                                                    )
                                            )}
                                        </TableHead>
                                    </Table>
                                </div>

                                <div>
                                    <Table>
                                        <TableBody>
                                            <TableRow key="1">
                                                <TableCell>Total Qty</TableCell>
                                                <TableCell>{procurementDetails?.totalQty}</TableCell>
                                            </TableRow>
                                            <TableRow key="2">
                                                <TableCell>
                                                    Freight Approved
                                                </TableCell>
                                                <TableCell>₹{Math.round(procurementDetails?.totalFreightApproved)}</TableCell>
                                            </TableRow>
                                            <TableRow key="3">
                                                <TableCell>
                                                    <i>Freight Charge</i>
                                                </TableCell>
                                                <TableCell>
                                                    {freightCharge}
                                                </TableCell>
                                            </TableRow>
                                            <TableRow key="4">
                                                <TableCell>
                                                    <i>GST Rate</i>
                                                </TableCell>
                                                <TableCell>
                                                    {procurementDetails?.gstDetails ? (procurementDetails.gstDetails.length !== 0 ? (procurementDetails.gstDetails[0].rate ? procurementDetails.gstDetails[0].rate : 'N/A') : 'N/A') : "N/A"}%
                                                </TableCell>
                                            </TableRow>
                                            <TableRow key="5">
                                                <TableCell>
                                                    <i>Gst Charge</i>
                                                </TableCell>
                                                <TableCell>
                                                    {gstAmounts}
                                                </TableCell>
                                            </TableRow>
                                            <TableRow key="6">
                                                <TableCell>Total Amount</TableCell>
                                                <TableCell>
                                                    ₹{Math.round(procurementDetails?.grandTotal)}
                                                </TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style={{ border: "1px solid #000", flex: 1, padding: "" }}>
                        {
                            // Display pdf when file type is pdf
                            getFileType(details?.InwardingRecords?.invoice) === "pdf" ? (
                                <iframe
                                    title="PDF Viewer"
                                    src={`https://docs.google.com/gview?url=${details?.InwardingRecords?.invoice}&embedded=true`}
                                    style={{
                                        width: "fit-content",
                                        height: "800px",
                                        border: "none",
                                    }}
                                ></iframe>
                            ) : // Display image when file is image
                                getFileType(details?.InwardingRecords?.invoice) === "image" ? (
                                    <img
                                        src={details?.InwardingRecords?.invoice}
                                        width="100%"
                                        alt="Image"
                                    ></img>
                                ) : (
                                    // Display warning when file type is not supported
                                    <p style={{ color: "red", padding: "10%" }}>
                                        <b>File Format Not Supported</b>
                                    </p>
                                )
                        }
                    </div>
                </div>

                <DialogActions>
                    <Button
                        onClick={() => openRemarksModalHandler("Rejected")}
                        color="secondary"
                        variant="outlined"
                    >
                        Reject
                    </Button>
                    <Button
                        onClick={() => openRemarksModalHandler("Approved")}
                        color="primary"
                        variant="contained"
                        style={{ background: "#2b7636", margin: 5 }}
                    >
                        Approve
                    </Button>
                </DialogActions>
            </Modal>
            */}

            {/* Remarks Dialog Box  */}
            {/*
            <div>
                <Dialog
                    open={openRemarksModal}
                    onClose={closeRemarksModalHandler}
                    aria-labelledby="form-dialog-title"
                    maxWidth="sm"
                    fullWidth
                >
                    <DialogContent>
                        <DialogContentText>Enter {textContent} Remarks</DialogContentText>
                        <TextField
                            id="remarks"
                            name="Remarks"
                            label="Add Remarks"
                            variant="outlined"
                            type="text"
                            value={remarks}
                            onChange={remarksInputHandler}
                            fullWidth
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button
                            variant="outlined"
                            onClick={closeRemarksModalHandler}
                            color="secondary"
                        >
                            Cancel
                        </Button>
                        <Button
                            onClick={handleFinanceInwardingActionForFreightChangeApproval}
                            variant="contained"
                            color="primary"
                            style={{ background: "#2b7636", margin: 5 }}
                        >
                            Submit
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
            */}
        </div>
    );
};

export default connect(null, { setLoading, setSnackInfo })(
    PaymentExcelDownload
);